export const IS_MOBILE_MODE_SIZE = 1000
